export * from './phoneme-quiz.component';
